export const LotType = {
  flat: 'flats',
  commercial: 'commercial',
};
